import SubLabel from "components/Atoms/Sublabel";
import React from "react";
import { RemovableLabel, RemovableProps } from "./Removable";
import { GooglePlaceState } from "shared/utils/fieldsHelper/groundFields";

const RemovableGooglePlace = (props: RemovableProps<GooglePlaceState>) => {
  return <RemovableLabel {...props}>
    <div>
      <div>{props.value.name}</div>
      <SubLabel>{props.value.address}</SubLabel>
    </div>
  </RemovableLabel>
};

export default RemovableGooglePlace;